class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }


  shippingProgressBar(totalprice) {
    if (currencyRate != null && shippingStatus == true) {
      let shippingText = ''
      let currencyConvertRate = Math.round(currencyRate * (Shopify.currency.rate || 1));
      let getcurrencySymbol = Shopify.currency.active;
      totalprice = totalprice / 100;
      let shippingPrice = currencyConvertRate - totalprice;

      $('[data-shipping-bar-wrapper]').removeClass('finish');
      if (shippingPrice > 0) {
        shippingPrice = shippingPrice.toFixed(2)
        let shippingpricemessage = shippingPrice + ' ' + getcurrencySymbol;
        shippingText = shippingmessage.replace('||price||', shippingpricemessage)
      } else {
        shippingText = shippingsuccessmessage;
        $('[data-shipping-bar-wrapper]').addClass('finish');
      }
      let shippingRatePercentage = (totalprice * 100) / currencyConvertRate;
      if (shippingRatePercentage > 10 && shippingRatePercentage < 100) {
        shippingRatePercentage = parseFloat(shippingRatePercentage) - 5
      }
      else if (shippingRatePercentage > 100) {
        shippingRatePercentage = 100
      }
      shippingRatePercentage = Math.trunc(shippingRatePercentage);
      if (document.querySelector("[data-shipping-bar-wrapper]")) {
        let shippingSelector = document.querySelector("[data-shipping-bar-wrapper]");
        shippingSelector.classList.remove("hidden");
        shippingSelector.querySelector(".free-shipping-message").textContent = shippingText;
        shippingSelector.querySelector("[data-shipping-bar]").style.width = shippingRatePercentage + '%'
        // shippingSelector.querySelector("[data-shipping-percentage]").textContent=shippingRatePercentage+'%';
      }
    }

  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');


    setTimeout(function () {
      fetch("/cart.js")
        .then(response => response.json())
        .then((data) => {
          let totalprice = data.total_price;
          shippingProgressBar(totalprice)

        })
    }, 500)
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });


    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });


    setTimeout(function () {
      fetch("/cart.js")
        .then(response => response.json())
        .then((data) => {
          let totalprice = data.total_price;
          shippingProgressBar(totalprice)
        })
    }, 500)
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
